import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactsPage = ({ onBack }) => {
  const { t } = useTranslation();

  const contactsData = [
    {
      id: 1,
      title: '«Яковлев»',
      phones: ['8 (8555) 75-91-03', '8 (986) 710 02-23'],
      internal: '5925',
      address: 'ул. Ш-2, 5/14',
      location: 'R&D центр «Яковлев»',
      email: 'AlabugaMed@alabuga.ru',
      icon: '🏢'
    },
    {
      id: 2,
      title: '«Общественный центр»',
      phones: ['8 (8555) 75-90-06'],
      internal: '5776',
      address: 'ул. Норд Драйв, 3/4',
      icon: '🏛️'
    },
    {
      id: 3,
      title: '«Синергия 22.2»',
      phones: ['8 (8555) 75-90-06'],
      internal: '5691',
      address: 'ул. Ш-2, 4/3',
      icon: '🏥'
    }
  ];

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert(`Скопировано: ${text}`);
  };

  const handleCall = (phone) => {
    const cleanPhone = phone.replace(/[^\d+]/g, '');
    window.location.href = `tel:${cleanPhone}`;
  };

  const handleMap = (address) => {
    const query = encodeURIComponent(address);
    window.open(`https://yandex.ru/maps/?text=${query}`, '_blank');
  };

  const handleEmail = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="contacts-page">
      <header className="health-check-header">
        <button className="back-btn" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          На главную
        </button>
        <h1 className="health-check-title">Наши контакты</h1>
      </header>

      <main className="health-check-content">
        <div className="intro-section">
          <div className="intro-content">
            <h2>Контакты клиники</h2>
            <p className="intro-text">
              Свяжитесь с нами удобным для вас способом
            </p>
          </div>
        </div>

        <div className="contacts-list">
          {contactsData.map((contact) => (
            <div key={contact.id} className="contact-card">
              <div className="contact-card-header">
                <div className="action-icon" style={{ fontSize: '32px', width: '60px', height: '60px' }}>
                  {contact.icon}
                </div>
                <div className="action-text">
                  <span className="action-title">{contact.title}</span>
                </div>
              </div>

              <div className="contact-card-content">
                {/* Телефоны */}
                <div className="contact-section">
                  <div className="contact-section-title">
                    <span>📞 Телефоны</span>
                  </div>
                  <div className="contact-phones">
                    {contact.phones.map((phone, index) => (
                      <div key={index} className="contact-phone-item">
                        <button 
                          className="contact-phone-btn"
                          onClick={() => handleCall(phone)}
                        >
                          <span className="contact-phone-text">{phone}</span>
                          <span className="contact-phone-action">Позвонить</span>
                        </button>
                        <button 
                          className="contact-copy-btn"
                          onClick={() => handleCopy(phone)}
                          title="Копировать номер"
                        >
                          📋
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Внутренний номер */}
                <div className="contact-section">
                  <div className="contact-section-title">
                    <span>📞 Внутренний номер</span>
                  </div>
                  <div className="contact-internal">
                    <span className="contact-internal-number">{contact.internal}</span>
                    <button 
                      className="contact-copy-btn"
                      onClick={() => handleCopy(contact.internal)}
                      title="Копировать номер"
                    >
                      📋
                    </button>
                  </div>
                </div>

                {/* Адрес */}
                <div className="contact-section">
                  <div className="contact-section-title">
                    <span>📍 Адрес</span>
                  </div>
                  <div className="contact-address">
                    <span className="contact-address-text">
                      {contact.location && `${contact.location}, `}
                      {contact.address}
                    </span>
                    <button 
                      className="contact-map-btn"
                      onClick={() => handleMap(contact.address)}
                    >
                      <span className="map-btn-icon">🗺️</span>
                      <span className="map-btn-text">На карте</span>
                    </button>
                  </div>
                </div>

                {/* Email (только для Яковлева) */}
                {contact.email && (
                  <div className="contact-section">
                    <div className="contact-section-title">
                      <span>✉️ Email</span>
                    </div>
                    <div className="contact-email">
                      <button 
                        className="contact-email-btn"
                        onClick={() => handleEmail(contact.email)}
                      >
                        <span className="contact-email-text">{contact.email}</span>
                        <span className="contact-email-action">Написать</span>
                      </button>
                      <button 
                        className="contact-copy-btn"
                        onClick={() => handleCopy(contact.email)}
                        title="Копировать email"
                      >
                        📋
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </main>

      <style jsx>{`
        .contacts-page {
          min-height: 100vh;
          padding: 16px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
        }

        .health-check-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 25px;
          padding-top: 10px;
        }

        .back-btn {
          background: rgba(41, 128, 185, 0.25);
          backdrop-filter: blur(20px);
          border: 2px solid rgba(52, 152, 219, 0.4);
          border-radius: 16px;
          padding: 14px 20px;
          color: white;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          font-weight: 600;
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          white-space: nowrap;
          flex-shrink: 0;
        }

        .back-btn:hover {
          background: rgba(52, 152, 219, 0.35);
          border-color: rgba(86, 204, 242, 0.6);
          transform: translateY(-2px);
        }

        .health-check-title {
          color: white;
          font-size: 22px;
          font-weight: 700;
          margin: 0;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          line-height: 1.3;
          flex: 1;
          text-align: center;
        }

        .health-check-content {
          animation: fadeIn 0.4s ease-out;
        }

        .intro-section {
          background: rgba(41, 128, 185, 0.15);
          backdrop-filter: blur(15px);
          border: 2px solid rgba(52, 152, 219, 0.3);
          border-radius: 20px;
          padding: 25px 20px;
          margin-bottom: 25px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          text-align: center;
        }

        .intro-content h2 {
          color: white;
          font-size: 20px;
          font-weight: 700;
          margin: 0 0 12px 0;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        }

        .intro-text {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          line-height: 1.5;
          margin: 0;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .contacts-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 25px;
        }

        .contact-card {
          background: rgba(41, 128, 185, 0.25);
          backdrop-filter: blur(20px);
          border: 2px solid rgba(52, 152, 219, 0.4);
          border-radius: 18px;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
        }

        .contact-card:hover {
          transform: translateY(-3px);
          background: rgba(52, 152, 219, 0.35);
          border-color: rgba(86, 204, 242, 0.6);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
        }

        .contact-card-header {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px;
          background: linear-gradient(135deg, rgba(41, 128, 185, 0.3), rgba(52, 152, 219, 0.2));
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .action-icon {
          font-size: 36px;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          border: 2px solid rgba(255, 255, 255, 0.2);
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .contact-card:hover .action-icon {
          background: rgba(255, 255, 255, 0.2);
          border-color: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }

        .action-text {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .action-title {
          color: white;
          font-size: 18px;
          font-weight: 700;
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          line-height: 1.3;
        }

        .contact-card-content {
          padding: 20px;
        }

        .contact-section {
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .contact-section:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .contact-section-title {
          color: rgba(86, 204, 242, 0.9);
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          gap: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .contact-phones {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .contact-phone-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(52, 152, 219, 0.3);
          border-radius: 14px;
          padding: 8px 8px 8px 16px;
          transition: all 0.3s ease;
        }

        .contact-phone-item:hover {
          background: rgba(52, 152, 219, 0.15);
          border-color: rgba(52, 152, 219, 0.5);
        }

        .contact-phone-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px 0;
          color: white;
        }

        .contact-phone-text {
          font-size: 15px;
          font-weight: 500;
          color: white;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .contact-phone-action {
          font-size: 13px;
          color: rgba(86, 204, 242, 0.9);
          font-weight: 600;
          margin-left: 10px;
        }

        .contact-copy-btn {
          background: rgba(255, 255, 255, 0.08);
          border: 2px solid rgba(255, 255, 255, 0.15);
          border-radius: 10px;
          width: 36px;
          height: 36px;
          color: white;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          margin-left: 8px;
        }

        .contact-copy-btn:hover {
          background: rgba(255, 255, 255, 0.15);
          border-color: rgba(255, 255, 255, 0.25);
          transform: scale(1.1);
        }

        .contact-internal {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(52, 152, 219, 0.3);
          border-radius: 14px;
          padding: 12px 16px;
        }

        .contact-internal-number {
          font-size: 16px;
          font-weight: 600;
          color: white;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .contact-address {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .contact-address-text {
          font-size: 15px;
          color: white;
          line-height: 1.5;
          padding: 8px 0;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .contact-map-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, rgba(52, 152, 219, 0.8), rgba(41, 128, 185, 0.8));
          border: 2px solid rgba(86, 204, 242, 0.4);
          border-radius: 14px;
          padding: 12px 20px;
          color: white;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          align-self: flex-start;
          backdrop-filter: blur(10px);
        }

        .contact-map-btn:hover {
          transform: translateY(-2px);
          background: linear-gradient(135deg, rgba(52, 152, 219, 0.9), rgba(41, 128, 185, 0.9));
          border-color: rgba(86, 204, 242, 0.6);
          box-shadow: 0 6px 15px rgba(52, 152, 219, 0.3);
        }

        .map-btn-icon {
          font-size: 16px;
        }

        .contact-email {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(52, 152, 219, 0.3);
          border-radius: 14px;
          padding: 8px 8px 8px 16px;
        }

        .contact-email-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px 0;
          color: white;
        }

        .contact-email-text {
          font-size: 14px;
          color: white;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .contact-email-action {
          font-size: 13px;
          color: rgba(86, 204, 242, 0.9);
          font-weight: 600;
          margin-left: 10px;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 480px) {
          .contacts-page {
            padding: 12px;
          }

          .health-check-header {
            gap: 12px;
            margin-bottom: 20px;
          }

          .back-btn {
            padding: 12px 16px;
            font-size: 14px;
          }

          .health-check-title {
            font-size: 20px;
          }

          .intro-section {
            padding: 20px 16px;
          }

          .intro-content h2 {
            font-size: 18px;
          }

          .intro-text {
            font-size: 13px;
          }

          .contact-card-header {
            padding: 18px;
          }

          .action-icon {
            font-size: 32px;
            width: 54px;
            height: 54px;
          }

          .action-title {
            font-size: 17px;
          }

          .contact-card-content {
            padding: 18px;
          }

          .contact-section {
            margin-bottom: 18px;
            padding-bottom: 18px;
          }

          .contact-phone-text {
            font-size: 14px;
          }

          .contact-phone-action {
            font-size: 12px;
          }

          .contact-internal-number {
            font-size: 15px;
          }

          .contact-address-text {
            font-size: 14px;
          }

          .contact-map-btn {
            padding: 10px 16px;
            font-size: 13px;
          }

          .contact-email-text {
            font-size: 13px;
          }
        }

        @media (max-width: 360px) {
          .health-check-title {
            font-size: 18px;
          }

          .contact-phone-item {
            flex-wrap: wrap;
          }

          .contact-phone-btn {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
          }

          .contact-phone-action {
            margin-left: 0;
          }

          .contact-email-btn {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
          }

          .contact-email-action {
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactsPage;